import FeatureSpecSectionDropdown from "components/feature-spec-section-dropdown";

export function FeatureSpecSectionCellEditor(props: any) {
  const { stopEditing, data, onValueChange } = props;

  return (
    <div className="w-full">
      <FeatureSpecSectionDropdown
        selectedIds={data?.spec_section?.map((spec: any) => spec.id)}
        onBlur={(ids, ops) => {
          onValueChange(ops.map((x: any) => ({ id: x.value, name: x.label })));
          setTimeout(() => {
            stopEditing();
          }, 200);
        }}
        mode="single"
        className="w-full"
        open
      />
    </div>
  );
}
